import { render, staticRenderFns } from "./circulardocumenttype.vue?vue&type=template&id=0848398e&"
import script from "./circulardocumenttype.vue?vue&type=script&lang=js&"
export * from "./circulardocumenttype.vue?vue&type=script&lang=js&"
import style0 from "./circulardocumenttype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports